import { render, staticRenderFns } from "./ePharmacyBase.vue?vue&type=template&id=2827d5c3&"
import script from "./ePharmacyBase.vue?vue&type=script&lang=js&"
export * from "./ePharmacyBase.vue?vue&type=script&lang=js&"
import style0 from "./ePharmacyBase.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports